import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'sa-choice-dialog',
  templateUrl: './choice-dialog.component.html',
  styleUrls: ['./choice-dialog.component.scss'],
})
export class ChoiceDialogComponent implements OnInit {
  data: any;

  constructor(public dialogRef: MatDialogRef<ChoiceDialogComponent>, @Inject(MAT_DIALOG_DATA) public _data: any) {
    this.data = _data;
  }

  ngOnInit() {}

  cancelAction() {
    this.dialogRef.close(false);
  }

  continueAction() {
    this.dialogRef.close(true);
  }
}
